import { connect } from 'react-redux';
import NewOrdersPage from './NewOrdersPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { getNewOrderData, rework } from 'src/actions/liveOrderAction';
// import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        newOrderData: state.liveOrder.newOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getHoldOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getNewOrderData);
        },
        reload: () => {
            dispatch(getNewOrderData);
        },
        // onRowClick: (orderid: string, rowData: string) => {
        //     dispatch(rowClick(orderid, rowData));
        // },
        // onDownloadClick: (filepath: string, fileName: string) => {
        //     dispatch(downloadURL(filepath, fileName, 'initial'));
        // },
        submitCancel: (column: Object) => {
            dispatch(rework(column, 'new'));
        },
    };
};

const LiveOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewOrdersPage);

export default LiveOrderContainer;



// WEBPACK FOOTER //
// ./src/components/NewOrdersPage/NewOrdersPageContainer.tsx